import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import GroupIcon from "@mui/icons-material/Group";
import AddHomeIcon from "@mui/icons-material/AddHome";
import HikingIcon from "@mui/icons-material/Hiking";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import StoreIcon from "@mui/icons-material/Store";
import EventIcon from "@mui/icons-material/Event";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import MoneyIcon from "@mui/icons-material/Money";
import GroupsIcon from "@mui/icons-material/Groups";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AssessmentIcon from "@mui/icons-material/Assessment";
import InfoIcon from "@mui/icons-material/Info";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CallIcon from "@mui/icons-material/Call";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SportsBaseballIcon from "@mui/icons-material/SportsBaseball";
import { Link } from "react-router-dom";
import { DarkModeContext } from "../../../context/darkModeContext";
import { useContext } from "react";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const { dispatch } = useContext(DarkModeContext);
  // Get adminType directly from Redux so it works on ALL pages
  const adminType = useSelector((state) => state.user.adminType);
  const clubName = useSelector((state) => state.user.clubName);

  // Helper to check if user is restricted
  const isRestricted =
    adminType === "Admin" || adminType === "Member" || adminType === "Toll";

  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/dashboard" style={{ textDecoration: "none" }}>
          <span className="logo">{clubName}</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to="/dashboard" style={{ textDecoration: "none" }}>
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>

          <p className="title">LISTS</p>
          {isRestricted ? (
            <>
              <li style={{ pointerEvents: "none", opacity: 0.5 }}>
                <PersonOutlineIcon className="icon" />
                <span>Users</span>
              </li>
              <li style={{ pointerEvents: "none", opacity: 0.5 }}>
                <AdUnitsIcon className="icon" />
                <span>Custom Ads</span>
              </li>
            </>
          ) : (
            <>
              <Link to="/users" style={{ textDecoration: "none" }}>
                <li>
                  <PersonOutlineIcon className="icon" />
                  <span>Users</span>
                </li>
              </Link>
              <Link to="/customads" style={{ textDecoration: "none" }}>
                <li>
                  <AdUnitsIcon className="icon" />
                  <span>Custom Ads</span>
                </li>
              </Link>
            </>
          )}

          <Link to="/news" style={{ textDecoration: "none" }}>
            <li>
              <NewspaperIcon className="icon" />
              <span>News</span>
            </li>
          </Link>
          <Link to="/ghar" style={{ textDecoration: "none" }}>
            <li>
              <AddHomeIcon className="icon" />
              <span>HomeStay</span>
            </li>
          </Link>
          <Link to="/market" style={{ textDecoration: "none" }}>
            <li>
              <StoreIcon className="icon" />
              <span>Local Market</span>
            </li>
          </Link>
          <Link to="/travel" style={{ textDecoration: "none" }}>
            <li>
              <HikingIcon className="icon" />
              <span>Local Trekking</span>
            </li>
          </Link>
          <Link to="/gtak" style={{ textDecoration: "none" }}>
            <li>
              <SmartDisplayIcon className="icon" />
              <span>Local Videos</span>
            </li>
          </Link>
          <Link to="/events" style={{ textDecoration: "none" }}>
            <li>
              <EventIcon className="icon" />
              <span>Local Events</span>
            </li>
          </Link>
          <Link to="/people" style={{ textDecoration: "none" }}>
            <li>
              <SettingsAccessibilityIcon className="icon" />
              <span>Population</span>
            </li>
          </Link>
          <li>
            <CalendarMonthIcon className="icon" />
            <span>Calendar</span>
          </li>

          <p className="title">USEFUL</p>
          {adminType === "Toll" ? (
            <>
              <li style={{ pointerEvents: "none", opacity: 0.5 }}>
                <GroupIcon className="icon" />
                <span>Members</span>
              </li>
              <li style={{ pointerEvents: "none", opacity: 0.5 }}>
                <SportsBaseballIcon className="icon" />
                <span>Mela</span>
              </li>
              <li style={{ pointerEvents: "none", opacity: 0.5 }}>
                <AttachMoneyIcon className="icon" />
                <span>Finance Mela</span>
              </li>
              <li style={{ pointerEvents: "none", opacity: 0.5 }}>
                <AttachMoneyIcon className="icon" />
                <span>Finance</span>
              </li>
              <li style={{ pointerEvents: "none", opacity: 0.5 }}>
                <MoneyIcon className="icon" />
                <span>Sponsor</span>
              </li>
            </>
          ) : (
            <>
              <Link to="/members" style={{ textDecoration: "none" }}>
                <li>
                  <GroupIcon className="icon" />
                  <span>Members</span>
                </li>
              </Link>
              <Link to="/mela" style={{ textDecoration: "none" }}>
                <li>
                  <SportsBaseballIcon className="icon" />
                  <span>Mela</span>
                </li>
              </Link>
              <Link to="/financeMela" style={{ textDecoration: "none" }}>
                <li>
                  <AttachMoneyIcon className="icon" />
                  <span>Finance Mela</span>
                </li>
              </Link>
              <Link to="/finance" style={{ textDecoration: "none" }}>
                <li>
                  <AttachMoneyIcon className="icon" />
                  <span>Finance</span>
                </li>
              </Link>
              <Link to="/sponsor" style={{ textDecoration: "none" }}>
                <li>
                  <MoneyIcon className="icon" />
                  <span>Sponsor</span>
                </li>
              </Link>
            </>
          )}

          <Link to="/meeting" style={{ textDecoration: "none" }}>
            <li>
              <GroupsIcon className="icon" />
              <span>Meeting</span>
            </li>
          </Link>
          <Link to="/notice" style={{ textDecoration: "none" }}>
            <li>
              <InfoIcon className="icon" />
              <span>Notice</span>
            </li>
          </Link>

          <p className="title">TOLL</p>
          <Link to="/toll" style={{ textDecoration: "none" }}>
            <li>
              <GroupsIcon className="icon" />
              <span>Add Toll</span>
            </li>
          </Link>
          <Link to="/gharNo" style={{ textDecoration: "none" }}>
            <li>
              <GroupsIcon className="icon" />
              <span>Add Ghar No</span>
            </li>
          </Link>

          <p className="title">TOLL REPORTs</p>
          <Link to="/tollFinanceReport" style={{ textDecoration: "none" }}>
            <li>
              <GroupsIcon className="icon" />
              <span>Toll Finance Report</span>
            </li>
          </Link>
          <Link to="/tollActivityReport" style={{ textDecoration: "none" }}>
            <li>
              <GroupsIcon className="icon" />
              <span>Toll Activity Report</span>
            </li>
          </Link>

          <p className="title">REPORTS</p>
          <Link to="/financeReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Finance Report</span>
            </li>
          </Link>
          <Link to="/melaReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Mela Report</span>
            </li>
          </Link>
          <Link to="/sponsorReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Sponsor Report</span>
            </li>
          </Link>
          <Link to="/meetingReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Meeting Report</span>
            </li>
          </Link>
          <Link to="/memberReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Members Report</span>
            </li>
          </Link>
          <Link to="/eventsReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Events Report</span>
            </li>
          </Link>
          <Link to="/noticeReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Notice Board Report</span>
            </li>
          </Link>
          <Link to="/homeStayReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>HomeStay Report</span>
            </li>
          </Link>
          <Link to="/marketReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Bazar Report</span>
            </li>
          </Link>
          <Link to="/travelReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Travel Report</span>
            </li>
          </Link>
          <Link to="/peopleReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Population Report</span>
            </li>
          </Link>
          <Link to="/userReport" style={{ textDecoration: "none" }}>
            <li>
              <AssessmentIcon className="icon" />
              <span>Club and Village Report</span>
            </li>
          </Link>

          <p className="title">USER</p>
          <li>
            <AccountCircleOutlinedIcon className="icon" />
            <span>Profile</span>
          </li>
          <Link to="/contactInfo" style={{ textDecoration: "none" }}>
            <li>
              <CallIcon className="icon" />
              <span>Contact Us</span>
            </li>
          </Link>
          <Link to="/" style={{ textDecoration: "none" }}>
            <li>
              <ExitToAppIcon className="icon" />
              <span>Logout</span>
            </li>
          </Link>
        </ul>
      </div>
      <div className="bottom">
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div>
    </div>
  );
};

export default Sidebar;
